import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const OurSuppliers = () => {
  const { logos, partners } = useStaticQuery(
    graphql`
      query {
        logos: allFile(
          filter: {
            relativeDirectory: { eq: "assets/images/our-team/suppliers" }
          }
          sort: { name: ASC }
        ) {
          edges {
            node {
              name
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  quality: 100
                  placeholder: BLURRED
                  height: 55
                  transformOptions: { fit: CONTAIN }
                )
              }
            }
          }
        }
        partners: allFile(
          filter: {
            relativeDirectory: { eq: "assets/images/our-team/partners" }
          }
          sort: { name: ASC }
        ) {
          edges {
            node {
              name
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  quality: 100
                  placeholder: BLURRED
                  width: 140
                  height: 103
                  backgroundColor: "transparent"
                  transformOptions: { fit: CONTAIN }
                )
              }
            }
          }
        }
      }
    `
  );

  return (
    <Container id="our-suppliers">
      <div>
        <h3>Our Suppliers</h3>
        <p>
          We use best-in-class technology providers to power our laboratory
          service offerings
        </p>
      </div>
      <Track>
        {logos.edges.map((logo, i) => (
          <LogoContainer delay={i + 1} length={logos.edges.length}>
            <Logo
              image={getImage(logo.node)}
              alt={logo.node.name}
              imgStyle={{
                objectFit: "contain",
              }}
            />
          </LogoContainer>
        ))}
      </Track>
      <br />
      <div>
        <h3>Partners and Collaborations</h3>
      </div>
      <Track>
        {partners.edges.map((logo, i) => (
          <LogoContainer delay={i + 1} length={partners.edges.length}>
            <Logo image={getImage(logo.node)} alt={logo.node.name} i={i} />
          </LogoContainer>
        ))}
      </Track>
    </Container>
  );
};

const Container = styled.section`
  grid-column: 1 / 7;
  padding: 3rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  text-align: center;
  @media screen and (min-width: 1024px) {
    grid-column: 3 / 11;
    padding: 0 0 6rem 0;
    gap: 3rem;
    p {
      font-size: 1.25rem;
    }
  }
  @media screen and (min-width: 1600px) {
    grid-column: 4 / 10;
  }
`;

const Track = styled.div`
  width: 100%;
  max-width: 1024px;
  margin-inline: auto;
  position: relative;
  height: 4rem;
  overflow: visible;
  mask-image: linear-gradient(
    to right,
    rgba(248, 248, 248, 0),
    rgba(248, 248, 248, 1) 10%,
    rgba(248, 248, 248, 1) 90%,
    rgba(248, 248, 248, 0)
  );
`;

const LogoContainer = styled(motion.div)`
  height: 4rem;
  min-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  min-width: 160px;
  padding: 0 1rem;
  position: absolute;
  left: ${({ length }) => `max(calc(160px * ${length}), 100%)`};
  animation-name: scrollLeft;
  animation-duration: 30s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-delay: ${({ delay, length }) =>
    `calc(30s / ${length} * (${length} - ${delay}) * -1)`};
  overflow: visible;
  @keyframes scrollLeft {
    to {
      left: -160px;
    }
  }
`;

const Logo = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  max-width: 7.5rem;
  max-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: visible !important;
    img {
      object-fit: contain;
      width: 100%;
      height: 100%;
      display: block;
      margin: auto;
    }
  }
`;

export default OurSuppliers;
